module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === false),
      expression: "open === false"
    }],
    staticClass: "float-menu"
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": function($event) {
        _vm.$store.commit('changeShowMenu', false)
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "outside"
  }, [(_vm.user !== null) ? _c('div', {
    staticClass: "info-button",
    on: {
      "click": function($event) {
        _vm.$store.commit('showInfoMenu', true)
      }
    }
  }, [_vm._v(" ☰")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-battle float-item",
    attrs: {
      "to": "/votev"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Rösta")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-profile float-item",
    attrs: {
      "to": "/profile"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Profil")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-ar float-item",
    attrs: {
      "to": "/ar"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Glasögon")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d776909a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FloatMenu.vue
// module id = 120
// module chunks = 0